<template>
  <v-card>
    <v-card-title class="headline">{{ cardTitle }}</v-card-title>
    <v-divider></v-divider>
    <v-container>
      <p v-if="action === 'delete'" class="title ml-3">
        Are you sure?
      </p>
      <v-form v-else>
        <v-menu
          ref="datePickerMenu"
          v-model="datePickerMenu"
          :close-on-content-click="false"
          :return-value.sync="record.date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="record.date"
              label="Date"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              :error-messages="formErrors.date"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="record.date"
            :allowed-dates="isDateAllowed"
            no-title
            scrollable
            first-day-of-week="1"
            color="primary"
            @change="$refs.datePickerMenu.save(record.date)"
          >
          </v-date-picker>
        </v-menu>

        <v-row>
          <v-col>
            <v-text-field
              v-model="record.weight"
              label="Weight"
              prepend-icon="mdi-scale-bathroom"
              type="number"
              step="0.1"
              :error-messages="formErrors.weight"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-alert v-if="formErrors.non_field_errors" type="error" text dense>{{
          formErrors.non_field_errors[0]
        }}</v-alert>
      </v-form>
    </v-container>
    <v-card-actions>
      <v-spacer />
      <v-btn text @click="closeDialog">Cancel</v-btn>
      <v-btn
        text
        :color="action === 'delete' ? 'error' : 'primary'"
        @click="submitForm"
        :loading="isWaitingForResponse"
        >{{ action === "delete" ? "delete" : "save" }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "TrainingWeightForm",

  props: {
    recordedDates: Array,
    action: {
      type: String,
      required: true,
      validator: function (value) {
        return ['create', 'edit', 'delete'].includes(value)
      }
    },
    propsRecord: {
      type: Object,
      default: function () {
        return {
          date: moment().format("YYYY-MM-DD"),
          weight: ""
        }
      }
    }
  },

  data: function () {
    return {
      record: this.propsRecord,
      datePickerMenu: false,
      formErrors: {
      },
      isWaitingForResponse: false
    }
  },

  computed: {
    cardTitle: function () {
      const cardTitles = {
        "create": "New Record",
        "edit": "Edit Record",
        "delete": "Delete Record",
      }
      return cardTitles[this.action]
    },
    formData: function () {
      const formData = {
        date: this.record.date,
        weight: this.record.weight
      }
      return formData
    }
  },

  methods: {
    closeDialog: function () {
      this.$emit('close-dialog')
    },
    isDateAllowed: function (date) {
      return !(this.recordedDates.includes(date))
    },
    submitForm: function () {
      this.isWaitingForResponse = true
      const submitMethods = {
        "create": this.createRecord,
        "edit": this.editRecord,
        "delete": this.deleteRecord
      }
      submitMethods[this.action]()
    },
    createRecord: function () {
      axios
        .post(
          `${process.env.VUE_APP_API_ROOT_URL}training/weight/`,
          this.formData,
          this.$store.getters.axiosConfig
        )
        .then((response) => {
          this.$store.commit("createWeightRecord", response.data)
          this.isWaitingForResponse = false
          this.closeDialog()
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    },
    editRecord: function () {
      axios
        .put(
          `${process.env.VUE_APP_API_ROOT_URL}training/weight/${this.record.id}/`,
          this.formData,
          this.$store.getters.axiosConfig
        )
        .then((response) => {
          this.$store.commit("updateWeightRecord", response.data)
          this.isWaitingForResponse = false
          this.closeDialog()
        })
        .catch(error => {
          this.formErrors = error.response.data
          this.isWaitingForResponse = false
        });
    },
    deleteRecord: function () {
      axios
        .delete(
          `${process.env.VUE_APP_API_ROOT_URL}training/weight/${this.record.id}/`,
          this.$store.getters.axiosConfig
        )
        .then(() => {
          this.$store.commit("deleteWeightRecord", this.record)
          this.isWaitingForResponse = false
          this.closeDialog()
        })
        .catch(() => {
          this.isWaitingForResponse = false
        });
    }
  },


}
</script>